/* Header link repairs.

   THE UNDERLYING PROBLEM. layout/luma.liquid binds a capture-phase click handler to
   `.lp header` that intercepts EVERY <a> and <button> inside it and opens the
   "under construction" overlay. Anything in the header that has a real destination has
   to be rescued from that handler explicitly.

   WHAT WAS BROKEN (measured 10 Aug):
     Shop        -> "/"                        real, but the overlay ate it
     Bestsellers -> "/collections/bestsellers" real, but the overlay ate it
     Discover    -> "#science"                 exists on the PDP, NOT on the homepage
     About       -> "#faq"                     exists on the PDP, NOT on the homepage
     Cart        -> "/cart"                    real, but the overlay ate it
   On the homepage the two anchors matched nothing, so both fell through to the overlay
   and Discover and About appeared to go to "the same place". That was the report.

   THE FIX, in two parts:
     1. Give Discover and About destinations that resolve from ANY page — Discover to the
        science block on the product page, About to the new #about section on the home
        page. Re-applied on an interval because the nav is rebuilt at runtime.
     2. Let every real link through. We register BEFORE the layout's inline script, so our
        listener runs first on the same element; stopImmediatePropagation() is what stops
        the overlay handler (stopPropagation() would not, since they share an element).
   Net effect: no nav item opens the overlay any more, because every one of them now
   points at something that exists.

   Scrolling uses an explicit window.scrollTo rather than scrollIntoView: the page has a
   sticky header plus an injected .subnav, so scrollIntoView lands the heading underneath
   them, and smooth behaviour was dropped over long distances (#faq sits ~7000px down). */
(function(){

var PRODUCT_PATH = '/products/copper-peptide-lifting-serum';

/* label (lowercased) -> where it should actually go */
function destinations(){
  var D = window.LUMA_NAV || {};
  return {
    'discover': PRODUCT_PATH + '#science',
    'about':    '/#about'
  };
}

function shopAllUrl(){
  var D=window.LUMA_NAV||{};
  return D.shop_all_url||'/collections/bestsellers';
}

function stickyOffset(){
  var h=0;
  var hdr=document.querySelector('.lp header');
  if(hdr && getComputedStyle(hdr).position==='sticky') h+=hdr.getBoundingClientRect().height;
  var sub=document.querySelector('.lp .subnav');
  if(sub && getComputedStyle(sub).position==='sticky') h+=sub.getBoundingClientRect().height;
  return h;
}

function goTo(target){
  var y=target.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 8;
  if(y<0) y=0;
  window.scrollTo({top:y,behavior:'smooth'});
  setTimeout(function(){
    if(Math.abs(window.pageYOffset-y)>120) window.scrollTo(0,y);
  },700);
}

/* point Discover and About at destinations that exist from every page */
function retarget(){
  var hdr=document.querySelector('.lp header');
  if(!hdr) return false;
  var map=destinations();
  var touched=false;
  hdr.querySelectorAll('a').forEach(function(a){
    var label=(a.textContent||'').trim().toLowerCase();
    if(map[label] && a.getAttribute('href')!==map[label]){
      a.setAttribute('href', map[label]);
      touched=true;
    }
  });
  return touched;
}

/* "/#about" while already on "/" should scroll, not reload */
function sameDocument(href){
  var hash=href.indexOf('#');
  if(hash<0) return null;
  var path=href.slice(0,hash) || location.pathname;
  if(path==='/') path='/';
  var frag=href.slice(hash);
  if(frag.length<2) return null;
  /* treat a locale prefix (/de/...) as the same document */
  var here=location.pathname.replace(/^\/[a-z]{2}(?=\/|$)/,'') || '/';
  if(path!==here) return null;
  return document.querySelector(frag);
}

function boot(){
  var hdr=document.querySelector('.lp header');
  if(!hdr||hdr.dataset.lumaLinkfix) return false;
  hdr.dataset.lumaLinkfix='1';

  retarget();

  hdr.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('a');
    if(!a) return;
    var href=a.getAttribute('href')||'';
    if(!href) return;

    /* in-page anchor that exists right here -> scroll to it */
    if(href.charAt(0)==='#' && href.length>1){
      var t=document.querySelector(href);
      if(t){
        e.preventDefault();
        e.stopImmediatePropagation();
        var ov0=document.getElementById('ucover');
        if(ov0) ov0.style.display='none';
        goTo(t);
      }
      return;
    }

    /* cross-page link with a fragment, but we are already on that page */
    var local=sameDocument(href);
    if(local){
      e.preventDefault();
      e.stopImmediatePropagation();
      goTo(local);
      return;
    }

    /* any other real destination: let the browser navigate, and make sure the
       overlay handler never sees the click */
    if(href.charAt(0)==='/' || /^https?:/i.test(href)){
      e.stopImmediatePropagation();
      return;
    }
  },true);

  /* the overlay CTA should take you to what is actually open */
  var iv=setInterval(function(){
    var btn=document.querySelector('#ucover .ucbtn');
    if(!btn) return;
    clearInterval(iv);
    if(btn.dataset.lumaCta) return;
    btn.dataset.lumaCta='1';
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopImmediatePropagation();
      window.location.href=shopAllUrl();
    },true);
  },150);
  setTimeout(function(){ clearInterval(iv); },8000);

  /* the nav is rebuilt at runtime, so keep re-applying the hrefs for a while */
  var r=0, ri=setInterval(function(){ r++; retarget(); if(r>30) clearInterval(ri); },200);

  return true;
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',function(){
    if(boot()) return;
    var n=0,t=setInterval(function(){ n++; if(boot()||n>40) clearInterval(t); },100);
  });
}else{
  if(!boot()){ var n=0,t=setInterval(function(){ n++; if(boot()||n>40) clearInterval(t); },100); }
}
})();